import { createContext } from "react";
import type { CookiePreferences } from "./cookieConsentStore";

export interface CookieConsentContextValue {
  /** null until a choice has been made (or reloaded from storage) — drives whether the banner shows. */
  preferences: CookiePreferences | null;
  preferencesOpen: boolean;
  openPreferences: () => void;
  closePreferences: () => void;
  acceptAll: () => void;
  rejectNonEssential: () => void;
  savePreferences: (prefs: CookiePreferences) => void;
}

export const CookieConsentContext = createContext<CookieConsentContextValue | null>(null);
